export const newGraphStep = (childStepId = null, childStepRelation = 'exit', type) => {
  const blank = {
    exit: null,
    child: null,
    branches: [],
    type
  };
  if (['exit', 'child'].includes(childStepRelation)) {
    blank[childStepRelation] = childStepId;
  } else if (childStepRelation === 'branch') {
    blank.branches.push(childStepId);
  }
  return blank;
};
